export const IMAGE_BACKGROUND_PRESETS = {
  white: "#ffffff",
  black: "#000000",
} as const;

export type ImageBackgroundPreset = keyof typeof IMAGE_BACKGROUND_PRESETS;

const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/;

/** Normalize a hex color string or return null when empty/invalid. */
export function normalizeHexColor(raw: unknown): string | null {
  if (raw == null || raw === "") return null;
  const value = String(raw).trim();
  if (!value) return null;
  const withHash = value.startsWith("#") ? value : `#${value}`;
  if (!HEX_COLOR_RE.test(withHash)) return null;
  return withHash.toLowerCase();
}

export function isValidHexColor(raw: unknown): raw is string {
  return normalizeHexColor(raw) != null;
}
